export const DEFAULT_CLEAKER_NAMESPACE_SURFACE_ORIGIN = 'https://cleaker.me';
export const DEFAULT_CLEAKER_LOCAL_SURFACE_ORIGIN = 'http://localhost';
export const DEFAULT_CLEAKER_LAN_PORT = 8161;

// Backward-compatible aliases. These now represent host-level default surfaces,
// not port-pinned daemon channels.
export const DEFAULT_CLEAKER_NAMESPACE_ORIGIN = DEFAULT_CLEAKER_NAMESPACE_SURFACE_ORIGIN;
export const DEFAULT_CLEAKER_DEVELOPMENT_ORIGIN = DEFAULT_CLEAKER_LOCAL_SURFACE_ORIGIN;
